// Section 9 — Pricing. Anchor id="pricing" (Header nav target).
// Single flat-rate pricing card: one centered price, no intro window.
const FEATURES = [
  'First 3 lessons free — no card required',
  'Full access to every live certification track',
  'Adaptive remediation when you struggle',
  'Live job listings in your dashboard',
  'Cancel any time — no fee',
];

export default function PricingSection() {
  return (
    <section className="pr-sec" id="pricing">
      <div className="pr-inner">
        <h2 className="pr-h2">Pricing.</h2>
        <p className="pr-sub">3 lessons at no cost. No card required.</p>

        <div className="pr-featured">
          <span className="pr-badge">Membership</span>

          <div className="pr-strip">
            <div className="pr-cell">
              <p className="pr-cell-price">$21.99</p>
              <p className="pr-cell-sub">/month</p>
            </div>
          </div>

          <ul className="pr-features">
            {FEATURES.map(f => (
              <li key={f}><span className="pr-check">✓</span>{f}</li>
            ))}
          </ul>

          <a href="/registration" className="pr-cta">Start Free Lessons</a>
          <p className="pr-cta-micro">No card required to start.</p>
        </div>
      </div>

      <style>{`
        .pr-sec {
          position: relative; z-index: 1;
          padding: clamp(48px, 8vh, 96px) clamp(16px, 4vw, 40px);
          scroll-margin-top: 120px;
        }
        .pr-inner { max-width: 1000px; margin: 0 auto; text-align: center; }
        .pr-h2 {
          font-family: 'Fraunces', serif; font-weight: 500;
          font-size: clamp(28px, 4vw, 44px); line-height: 1.1;
          letter-spacing: -0.02em; margin: 0;
        }
        .pr-sub {
          font-weight: 300; color: rgba(17,17,16,0.62);
          font-size: clamp(15px, 1.8vw, 18px);
          margin: 18px auto 0; text-align: center;
        }

        .pr-featured {
          position: relative; margin: clamp(36px, 5vw, 56px) auto 0; max-width: 560px;
          background: #ffffff; box-shadow: 0 8px 30px rgba(0,0,0,0.08);
          border: 1px solid rgba(0,0,0,0.08);
          border-radius: 16px;
          padding: 40px;
          text-align: left;
        }
        .pr-badge {
          position: absolute; top: -13px; left: 50%; transform: translateX(-50%);
          background: linear-gradient(135deg, #f59e0b, #d97706); color: #ffffff;
          font-size: 11.5px; font-weight: 800; letter-spacing: .08em; text-transform: uppercase;
          padding: 6px 16px; border-radius: 99px; white-space: nowrap;
        }

        /* Single centered pricing strip. */
        .pr-strip {
          display: grid;
          grid-template-columns: 1fr;
          justify-items: center;
          padding: 0 0 28px;
          border-bottom: 1px solid rgba(217,119,6,0.18);
          margin: 4px 0 0;
        }
        .pr-cell {
          display: flex; flex-direction: column; align-items: center; text-align: center;
        }
        .pr-cell-price {
          font-family: 'Fraunces', serif; font-weight: 500;
          font-size: clamp(40px, 6.4vw, 56px);
          color: #111110; line-height: 1;
          margin: 10px 0 0;
        }
        .pr-cell-sub {
          font-family: 'Hanken Grotesk', sans-serif;
          font-size: 13.5px; color: rgba(17,17,16,0.6);
          margin: 8px 0 0;
        }

        .pr-features { list-style: none; margin: 26px 0 0; padding: 0; display: flex; flex-direction: column; gap: 13px; }
        .pr-features li { display: flex; align-items: flex-start; gap: 11px; font-size: 15px; line-height: 1.45; color: rgba(17,17,16,0.85); }
        .pr-check {
          display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0;
          width: 20px; height: 20px; border-radius: 50%; margin-top: 1px;
          background: rgba(5,150,105,0.14); color: #059669; font-size: 11px; font-weight: 800;
        }

        .pr-cta {
          display: flex; align-items: center; justify-content: center; margin-top: 28px;
          background: linear-gradient(135deg, #f59e0b, #d97706); color: #ffffff;
          font-size: 16px; font-weight: 700; padding: 15px 30px; border-radius: 12px;
          text-decoration: none; box-shadow: 0 6px 22px rgba(217,119,6,0.30);
          transition: transform .18s ease, box-shadow .18s ease;
        }
        .pr-cta:hover { transform: translateY(-2px); box-shadow: 0 10px 30px rgba(217,119,6,0.42); }
        .pr-cta-micro {
          font-size: 12.5px; color: rgba(17,17,16,0.5); text-align: center;
          margin: 14px 0 0; line-height: 1.5;
        }

        @media (max-width: 560px) {
          .pr-featured { padding: 32px 24px; }
          .pr-strip { padding-bottom: 22px; }
        }
      `}</style>
    </section>
  );
}
